<template>
  <v-card variant="outlined">
    <v-card-item>
      <p class="text-body-1 mb-2">Flyer Embed Code</p>

      <code>
        <v-textarea
          :value="flyerEmbedCode"
          auto-grow
          flat
          hide-details
          readonly
          rows="4"
          theme="dark"
          variant="solo-filled"
        ></v-textarea>
      </code>
    </v-card-item>

    <v-card-actions>
      <v-btn @click="copyText">{{ isCopied ? 'Copied!' : 'Copy Code' }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import { computed, ref, toRef } from 'vue'
import { usePageContext } from '#root/renderer/usePageContext'

const props = defineProps({
  occasion: {
    required: true,
    type: Object
  }
})

const isCopied = ref(false)
const occasion = toRef(() => props.occasion)
const { canonicalPaths } = usePageContext()
const flyerEmbedCode = computed(() => {
  let code

  if (occasion.value) {
    let href = ''
    switch (occasion.value?.product_variant?.product?.occasion_type?.code) {
      case 'C':
        href = `/widgets/flyer/courses/${occasion.value.product_variant.product.page_slug}`
        break
      case 'W':
        href = `/widgets/flyer/workshops/${occasion.value.product_variant.product.page_slug}`
        break
    }

    code = `<iframe frameborder="0" height="2500" src="${canonicalPaths.base}${href}?sku=${occasion.value.sku}" width="100%"></iframe>`
  }

  return code
})

function copyText() {
  if (navigator && navigator.clipboard)
    navigator.clipboard.writeText(flyerEmbedCode.value)

  isCopied.value = true
}
</script>
